export function isVariantGroupAttribute(attrib) {
  return attrib?.roles?.some(
    (r) => (r.type || r.Type) === "VARIANT_GROUP_CODE"
  );
}
